<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm"
            :model='userForm'
            label-position="right"
            :label-width="200"
            :rules="ruleValidate"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">
          <Col span="24">
            <FormItem label="用户名：">
              <Input
                v-model="userName"
                class="perW30"
                disabled
              />
            </FormItem>
          </Col>
          <Col>
            <FormItem label="头像">
              <div class="demo-upload-list" v-for="item in uploadList" :key="item.url" >
                <template v-if="item.status === 'finished'">
                  <img :src="server_url + item.url">
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                      v-if="uploadList.length==0"
                      ref="uploadThumb"
                      :show-upload-list="false"
                      :on-success="handleSuccess"
                      :format="['jpg','jpeg','png','gif']"
                      :max-size="10240"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload"
                      type="drag"
                      :action="serverApiPic"
                      style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                  <Icon type="ios-camera" size="20"></Icon>
                </div>
              </Upload>
              <Modal title="查看" v-model="visible">
                <img :src="server_url + imgUrl " v-if="visible" style="width: 100%">
              </Modal>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="密码：" prop="password">
              <Input
                type="password"
                v-model="userForm.password"
                class="perW30"
                placeholder="请输入密码(不输入则不改动)"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="确认密码：" prop="repassword">
              <Input
                type="password"
                v-model="userForm.repassword"
                class="perW30"
                placeholder="请输入确认密码(不输入则不改动)"
              />
            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Button
            type="primary"
            class="submission"
            @click="handleSubmit('userForm')"
          >保存</Button>
        </FormItem>

      </Form>
    </card>

  </div>

</template>
<style>
  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>
<script>
import { updateInfo } from '@/api/admin'
import Setting from '@/setting'
export default {
  name: 'contact',
  data () {
    return {
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      serverApiFile: Setting.serverApiFile,
      uploadList: [], // logo
      visible: false,
      imgUrl: '',
      userName: '',
      userForm: {
        id: 0,
        avatar: '',
        password: '',
        repassword: '',
        delpics: []
      },
      ruleValidate: {
      }
    }
  },
  created () {
    this.userForm.id = this.$store.state.user.userId
    this.userName = this.$store.state.user.userName
    let imgArr = this.$store.state.user.avatarImgPath.split('/uploads')
    this.uploadList.push({ 'url': '/uploads' + imgArr[1], 'showProgress': false, 'percentage': 100, 'status': 'finished' })//  logo
  },
  methods: {
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // logo删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.userForm.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // logo
    handleSuccess (res, file) {
      file.url = res.data.file_url
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    },
    handleSubmit (name) {
      this.userForm.avatar = this.uploadList.length > 0 ? this.uploadList[0]['url'] : ''
      this.$refs[name].validate(valid => {
        if (valid) {
          // console.log(this.userForm);return;
          updateInfo(this.userForm).then(res => {
            if (res.code === 200) {
              this.$Message.success('修改成功')
              this.$store.commit('setToken', '')
              this.$store.commit('setAccess', [])
              this.$router.push('/admin/login')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })

    }
  }
}
</script>
